import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-page">
      <div className="about">

        <h2>About TIK HR Consultancy</h2>

        <p>
          <strong>TIK HR Consultancy</strong> is committed to connecting talented
          individuals with rewarding career opportunities while helping
          organizations build high-performing teams. We specialize in
          recruitment solutions across IT, Non-IT, BPO, Banking, Finance,
          Aviation, Healthcare, Manufacturing, and various other industries.
        </p>

        <p>
          Our mission is to simplify the recruitment process by providing
          reliable hiring solutions for employers and personalized career
          guidance for job seekers. We believe every individual deserves the
          right opportunity to build a successful career, and every organization
          deserves access to the right talent.
        </p>

        <h3>Our Services</h3>

        <ul>
          <li>Job Placement Assistance</li>
          <li>Career Counselling & Guidance</li>
          <li>Professional Resume Building</li>
          <li>Interview Preparation & Mock Interviews</li>
          <li>Training & Skill Development Programs</li>
          <li>Permanent & Bulk Hiring Solutions</li>
          <li>Campus Recruitment</li>
          <li>Overseas Placement Assistance</li>
        </ul>

        <h3>Why Choose TIK HR Consultancy?</h3>

        <ul>
          <li>Dedicated recruitment professionals.</li>
          <li>Opportunities with leading MNCs and growing organizations.</li>
          <li>Personalized career guidance for every candidate.</li>
          <li>Quick and transparent recruitment process.</li>
          <li>Well-screened and qualified candidate database.</li>
          <li>Employer-focused hiring solutions.</li>
          <li>Continuous support throughout the recruitment journey.</li>
        </ul>

        <h3>For Candidates</h3>

        <p>
          We assist job seekers at every stage of their career journey—from
          identifying suitable opportunities and enhancing resumes to preparing
          for interviews and securing employment. Our goal is to improve your
          confidence, employability, and long-term career growth.
        </p>

        <h3>For Employers</h3>

        <p>
          We partner with organizations to provide efficient recruitment
          solutions by sourcing, screening, and delivering candidates who meet
          their business requirements. Whether it's individual hiring or bulk
          recruitment, we focus on quality, speed, and reliability.
        </p>

        <h3>Our Vision</h3>

        <p>
          To become one of India's most trusted recruitment and HR consultancy
          firms by creating meaningful career opportunities and delivering
          exceptional hiring solutions to organizations across industries.
        </p>

        <h3>Our Mission</h3>

        <p>
          To bridge the gap between talent and opportunity through ethical
          recruitment practices, professional guidance, innovative hiring
          solutions, and long-term partnerships with both candidates and
          employers.
        </p>

        <p>
          <strong>
            At TIK HR Consultancy, we believe in trust, transparency,
            professionalism, and long-term success—for both candidates and
            employers.
          </strong>
        </p>

      </div>
    </div>
  );
}

export default About;